<template>
	<div id="main" class="clear_margin">
		<header-top></header-top>
    <div class="container">
      <div class="swiper-main-boxs">
        <swiper>
          <swiper-slide>
            <div class="img-slide">
              <img src="./images/banner.jpg" alt="" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <introduce></introduce>
      <skill></skill>
      <product></product>
      <case-boxs></case-boxs>
    </div>
    
    <footer-bar></footer-bar>
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import headerTop from 'components/header/header'
import introduce from 'components/index/introduce'
import skill from 'components/index/skill'
import product from 'components/index/product'
import caseBoxs from 'components/index/case'
import footerBar from 'components/footer/footer'
export default {
  components: {
    headerTop,
    introduce,
    skill,
    product,
    caseBoxs,
    footerBar,
    swiper,
    swiperSlide
	},
	data(){
		return {
			
		}
	},
	created(){
	},
	methods: {
		
	}
}
</script>

<style scoped lang="scss">
  #main {
    .swiper-main-boxs {
      .img-slide {
        width: 100%;
        background-size: cover;
        img {
          width: 100%;
          display: block;
          font-size: 0;
        }
      }
    }
  }
  .container {
    padding-bottom: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/module/index/app.vue